import React from "react";
import AppButton from "../../shared/components/generic/button/app-button";
import ModalGeneric from "../../shared/components/generic/modal/modal-generic";
import { BsBoxArrowInDown, BsCheckCircle, BsDownload, BsExclamationTriangle } from "react-icons/bs";

const ETAPA_CONFIRMACAO = "confirmacao";
const ETAPA_PROGRESSO = "progresso";
const ETAPA_SUCESSO = "sucesso";

const ORIGEM_PERIODO = "periodo";
const ORIGEM_SELECIONADAS = "selecionadas";

const TEXTOS = {
  [ORIGEM_PERIODO]: {
    titulo: "Baixar todas do período",
    icone: BsBoxArrowInDown,
    progresso: "Todas as notas do período estão sendo compactadas em XML.",
    rotuloDoProgresso: "Progresso do download das notas do período",
    sucesso: "Todas as notas fiscais do período foram baixadas com sucesso em XML.",
  },
  [ORIGEM_SELECIONADAS]: {
    titulo: "Baixar selecionadas da página",
    icone: BsDownload,
    progresso: "As notas selecionadas estão sendo compactadas em XML.",
    rotuloDoProgresso: "Progresso do download das notas selecionadas",
    sucesso: "Download das notas selecionadas concluído com sucesso!",
  },
};

const NotasFiscaisModal = ({ etapa, origem = ORIGEM_PERIODO, progresso, periodo, quantidade, laboratorio, onConfirmar, onFechar }) => (
  <ModalGeneric
    id="modal-notas-fiscais"
    className="nf-modal"
    open={Boolean(etapa)}
    title={TEXTOS[origem].titulo}
    icon={TEXTOS[origem].icone}
    closable={etapa !== ETAPA_PROGRESSO}
    onClose={onFechar}
    footer={
      etapa === ETAPA_CONFIRMACAO && (
        <>
          <AppButton id="btn-cancelar-baixar-todas" className="nf-botao--contorno" onClick={onFechar}>
            Cancelar
          </AppButton>
          <AppButton id="btn-confirmar-baixar-todas" onClick={onConfirmar}>
            Confirmar e baixar em XML
          </AppButton>
        </>
      )
    }>
    {etapa === ETAPA_CONFIRMACAO && (
      <>
        <div className="nf-modal__alerta">
          <BsExclamationTriangle size={18} aria-hidden="true" />
          <p>
            Você está prestes a baixar <strong>todas as notas fiscais</strong> do período selecionado em formato <strong>XML</strong>, compactadas em um único
            arquivo .zip.
          </p>
        </div>

        <dl className="nf-modal__resumo">
          <div>
            <dt>Período</dt>
            <dd>{periodo}</dd>
          </div>
          <div>
            <dt>Formato</dt>
            <dd>XML</dd>
          </div>
          <div>
            <dt>Quantidade</dt>
            <dd>{quantidade === 1 ? "1 nota fiscal" : `${quantidade} notas fiscais`}</dd>
          </div>
          <div>
            <dt>Laboratório</dt>
            <dd>{laboratorio}</dd>
          </div>
        </dl>

        <p className="nf-modal__pergunta">Deseja confirmar e iniciar o download?</p>
      </>
    )}

    {etapa === ETAPA_PROGRESSO && (
      <div className="nf-modal__centralizado">
        <div className="nf-anel">
          <svg viewBox="0 0 36 36" aria-hidden="true">
            <circle className="nf-anel__trilho" cx="18" cy="18" r="15.9155" />
            <circle className="nf-anel__valor" cx="18" cy="18" r="15.9155" strokeDasharray={`${progresso} 100`} />
          </svg>
          <span>{progresso}%</span>
        </div>
        <p className="nf-modal__titulo">Preparando o download...</p>
        <p className="nf-modal__texto">{TEXTOS[origem].progresso}</p>
        <div
          className="nf-barra"
          role="progressbar"
          aria-label={TEXTOS[origem].rotuloDoProgresso}
          aria-valuemin={0}
          aria-valuemax={100}
          aria-valuenow={progresso}>
          <div className="nf-barra__valor" style={{ width: `${progresso}%` }} />
        </div>
        <p className="nf-modal__observacao">Não feche esta janela até o download ser concluído.</p>
      </div>
    )}

    {etapa === ETAPA_SUCESSO && (
      <div className="nf-modal__centralizado">
        <span className="nf-modal__icone-sucesso">
          <BsCheckCircle size={30} aria-hidden="true" />
        </span>
        <p className="nf-modal__titulo">Download concluído!</p>
        <p id="nf-modal-sucesso" className="nf-modal__texto">
          {TEXTOS[origem].sucesso}
        </p>
        <AppButton id="btn-fechar-baixar-todas" className="nf-botao" fullWidth autoFocus aria-describedby="nf-modal-sucesso" onClick={onFechar}>
          Fechar
        </AppButton>
      </div>
    )}
  </ModalGeneric>
);

export { ETAPA_CONFIRMACAO, ETAPA_PROGRESSO, ETAPA_SUCESSO, ORIGEM_PERIODO, ORIGEM_SELECIONADAS };
export default NotasFiscaisModal;
